import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { IntlProvider } from 'react-intl';
const IntlDefaults = {
    locale: 'en',
    setLocale: () => { },
};
export const IntlContext = React.createContext(IntlDefaults);
/**
 * Provides an internationalization context for the application.
 * Note: Locale switching is currently disabled. The locale is always 'en'.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Function} props.getMessages - A function that returns the messages for the specified locale.
 * @param {ReactNode} props.children - The child components to render within the context.
 * @returns {ReactNode} The rendered component.
 */
export const IntlContextProvider = ({ getMessages, children, }) => {
    const locale = 'en';
    // No-op function maintained for backwards compatibility with IntlInterface
    const handleSetLocale = () => { };
    const messages = useMemo(() => getMessages('en'), [getMessages]);
    const handleError = (err) => {
        if (err.code === 'MISSING_TRANSLATION') {
            if (process.env.NODE_ENV === 'development') {
                console.debug('Using key as fallback for translation:', err.descriptor?.id);
            }
            return;
        }
        console.error(err);
    };
    return (_jsx(IntlContext.Provider, { value: { locale, setLocale: handleSetLocale }, children: _jsx(IntlProvider, { locale: 'en', defaultLocale: 'en', messages: messages, onError: handleError, defaultRichTextElements: {
                b: chunks => _jsx("b", { children: chunks }),
                br: () => _jsx("br", {}),
                p: chunks => _jsx("p", { children: chunks }),
                ul: chunks => _jsx("ul", { children: chunks }),
                li: chunks => _jsx("li", { children: chunks }),
                ol: chunks => _jsx("ol", { children: chunks }),
            }, children: children }) }));
};
